import { useHandler } from "@redotech/react-util/hook";
import { useHasPermission } from "@redotech/redo-merchant-app-common/auth/permissions-context";
import { SettingsPermissions } from "@redotech/redo-model/permissions";
import { CloseChatState } from "@redotech/redo-return-ui/flows/chat-flow/close-chat";
import { containsImg } from "@redotech/redo-return-ui/flows/chat-flow/step-rich-text-util";
import { StepTypeDetailsProps } from "@redotech/redo-return-ui/flows/step";
import { LabeledInput } from "@redotech/redo-web/labeled-input";
import Quill from "quill";
import { memo, useRef } from "react";
import { StepRichTextEditor } from "./step-rich-text";

export const CloseChatDetails = memo(function Details({
  state,
  setState,
}: StepTypeDetailsProps<CloseChatState>) {
  // TODO: Not sure what the right permission mix is
  const canEditSupportSettings = useHasPermission(
    SettingsPermissions.SET_SUPPORT_SETTINGS,
  );
  const canEditReturnsSettings = useHasPermission(
    SettingsPermissions.SET_RETURNS_AND_CLAIMS_SETTINGS,
  );
  const canEditSettings = canEditSupportSettings || canEditReturnsSettings;

  const messageQuillRef = useRef<Quill | undefined>(undefined);

  const handleMessageChange = useHandler(() => {
    if (!messageQuillRef.current) {
      return;
    }
    let message = messageQuillRef.current.getText();
    let messageHtml: string | undefined =
      messageQuillRef.current.getSemanticHTML();
    if (message === "\n") {
      message = "";
    }
    if (messageHtml === "<p></p>") {
      messageHtml = undefined;
    }

    if (messageHtml !== state.messageHtml || message !== state.message) {
      setState((state) => ({ ...state, message, messageHtml }));
    }
  });

  return (
    <LabeledInput
      description="Message to show to the customer when the chat is closed"
      errors={containsImg(state.messageHtml) ? ["Cannot contain images"] : []}
      label="Message"
    >
      <StepRichTextEditor
        htmlValue={state.messageHtml}
        onTextChange={handleMessageChange}
        quillRef={messageQuillRef}
        readOnly={!canEditSettings}
        textValue={state.message}
      />
    </LabeledInput>
  );
});
